module.exports = __webpack_public_path__ + "static/media/20ECE26.4b7ac8dd.jpg";